import { useTranslation } from "react-i18next";
import { useRillContext } from "../../../../rill/RillReact/share/base";
import {
  calculateFreeTrialDaysLeft,
  isCoachConverted,
  isCoachFreeTrial,
  isPullActiveCoach,
} from "../../../../utils/user-helpers";
import { getRoleNameById } from "../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import { CustomWorkflowsList } from "../components/CustomWorkflowsList";
import LearnWorkflowsList from "../components/LearnWorkflowsList";
import { customWorkflowsList } from "../data/customWorkflowsList";

const CustomWorkflows = ({ userCanAccessToPush, userOrganizationCanAccessToWorkflows }) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { activeUser, organizationOwner, organizationRoles, query, workflows } =
    locals;
  const roleName = !!activeUser.organizationRoleId
    ? getRoleNameById(organizationRoles, activeUser.organizationRoleId)
    : "Owner";

  const isCoach =
    activeUser.permissions?.includes("coach") &&
    !(!organizationOwner && !isCoachConverted(activeUser));
  const isExpiredPull =
    isCoachFreeTrial(activeUser) && calculateFreeTrialDaysLeft(activeUser) < 1;
  const userToBindInformation =
    roleName === "Owner" ? activeUser : organizationOwner;

  const filteredWorkflows = workflows.filter((workflow) => {
    return workflow.access === query.access;
  });

  return (
    <main className="custom-workflows">
      <header>
        <hgroup className="mobile-hidden">
          <h3>{t("customWorkflows.title")}</h3>
          <p className="p4">{t("customWorkflows.description")}</p>
        </hgroup>
        <nav role="tablist">
          {userCanAccessToPush && userOrganizationCanAccessToWorkflows && (
            <a
              href="/actions/refresh?access=push"
              aria-current={
                !query.access || query.access === "push" || undefined
              }
            >
              {t("customWorkflows.subscriptionsPush")}
            </a>
          )}
          {!!isCoach &&
            !isExpiredPull &&
            isPullActiveCoach(userToBindInformation) && (
              <a
                href="/actions/refresh?access=pull"
                aria-current={query.access === "pull" || undefined}
              >
                {t("customWorkflows.coachingPull")}
              </a>
            )}
        </nav>
        {/* <ExploreSelector customWorkflowsList={customWorkflowsList} /> */}
      </header>
      <section>
        <LearnWorkflowsList
          customWorkflowsList={customWorkflowsList[query.access] || []}
          workflows={filteredWorkflows}
          access={query.access}
        />
        <CustomWorkflowsList workflows={filteredWorkflows} />
      </section>
    </main>
  );
};

export default CustomWorkflows;
